<script>
import moment from 'moment';

export default {
  name: 'SlotItemTableMobile',
  props: ['data', 'getDateAndMonth', 'getTime'],
  methods: {
    convertSlotDateToTime(slot) {
      const fullDateMoment = moment.utc(`${slot.start_date}T${slot.start_time}`);
      const fullDateUTC = fullDateMoment.utc().format();
      return this.getTime(fullDateUTC);
    }
  }
}
</script>

<template>
  <div class="invoice-rd">
    <table>
      <tbody>
        <tr>
          <td class="invoice-rd__content text-14 fw-700">{{'Service' | translate}}</td>
          <td>
            <p class="invoice-rd__content text-14 fw-500 color-default">{{data.treatment}}</p>
            <p class="invoice-rd__content text-12 fw-300">{{'Duration' | translate}}: {{data.duration}} min</p>
          </td>
        </tr>
        <tr>
          <td class="invoice-rd__content text-14 fw-700">{{'Booking Date' | translate}}</td>
          <td>
            <p class="invoice-rd__content text-14 fw-500 color-default">
              {{data.start_date}}
            </p>
            <p class="invoice-rd__content text-12 fw-300">{{'Time' | translate}} - {{convertSlotDateToTime(data)}}</p>
          </td>
        </tr>
        <tr>
          <td class="invoice-rd__content text-14 fw-700">{{'Price' | translate}}</td>
          <td>
            <p class="invoice-rd__content text-14 fw-500 color-default">
              {{parseFloat(data.price, 0).toFixed(2)}} CHF
            </p>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style lang="less" scoped>
@import "./../../less/redesign/vars";
.text-left {
  text-align: left;
}
.invoice-rd {
  border: 1px solid @grey-hover;
  border-radius: 20px;
  overflow: hidden;
  width: 100%;
  & table {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
  }
  & tr td:first-child {
    background-color: @grey-hover;
  }
  & td, th {
    padding: 20px 24px;
  }
  & tbody tr, tfoot tr:not(:last-child) {
    border-bottom: 1px solid @grey-hover;
  }
  &__content {
    text-align: center;
  }
  &__col-group {
    width: 200px;
  }

  @media screen and (max-width: 670px) {
    .invoice-rd__col-group {
      width: auto;
    }

    td,
    th {
      padding: 14px 10px;
    }
  }

  @media screen and (max-width: 420px) {
    td,
    th {
      display: block;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/health-advisor-widget/SlotItemTableMobile.vue